module.exports = __webpack_public_path__ + "static/logo-c247c4aabe1cfd5aa91013e075a36201.svg";